import { req } from '@/api'

// 获取AB测试数据
const getArrivedTimeBucket = () => {
  return new Promise(async (resolve, reject) => {
    const res = await req.getArrivedTimeBucket({
      testNameList: ["TECH_DISTANCE"]
    })
    let distance_test = ''
    let bucketName = ''
    if (res && res.code === 0) {
      console.log('technician:获取AB测试数据成功', res.data)
      // distance_test(实际距离到达时间ab）：A对照组、B-实验组、C-常规
      bucketName = res.data?.tests[0]?.bucketName
      if (bucketName) {
        switch (bucketName) {
          case 'DISTANCE':
            // 对照组逻辑 95%
            distance_test = 'A'
            break
          case 'DISTANCE_AND_DURATION':
            // 实验组逻辑 5%
            distance_test = 'B'
            break
          case 'C':
            // 常规组逻辑
            distance_test = 'C'
            break
        }
      } else {
        distance_test = 'A'
      }
    }
    console.log('AB测试数据组装后---', distance_test, bucketName)
    resolve({distance_test: distance_test, bucketName: bucketName })
  })
}
export { getArrivedTimeBucket }